<template lang="pug">
	.creative--insertion-newsml-settings(v-if="isNewsMLSettingsVisible")
		.flex-col.space
			.flex-col.field
				.font-small.upper.grey {{$tCaption('Timeout between news (ms)')}}
				DxNumberBox(:value.sync="record.jsonConfig.NewsMLConfig.TimeoutBetweenNews")
			.flex-col.field
				.font-small.upper.grey {{$tCaption('Delay before audio (ms)')}}
				DxNumberBox(:value.sync="record.jsonConfig.NewsMLConfig.DelayBeforeAudio")
			.flex-col.field
				.font-small.upper.grey {{$tCaption('Delay after audio (ms)')}}
				DxNumberBox(:value.sync="record.jsonConfig.NewsMLConfig.DelayAfterAudio")
</template>

<script>
	import DxNumberBox from 'devextreme-vue/number-box';

	export default {
		translationCategory: 'creative.CreativeInsertionNewsMLSettings',
		name: 'creative--insertion-newsml-settings',
		components: {
			DxNumberBox
		},
		props: ['record'],
		computed: {
			isNewsMLSettingsVisible() {
				return this.record?.jsonConfig?.NewsMLConfig && this.hasContentNewsMLTag;
			},
			hasContentNewsMLTag() {
				return (this.record?.ssml || '').indexOf('content@newsml') > -1;
			}
		},
		data() {
			return {
				
			};
		},
		mounted() {
			if (__DEBUG__)
				window.creativeNewsMLSettings = this;
			this.init();
		},
		methods: {
			init() {
				if (!this.record?.jsonConfig?.NewsMLConfig) {
					this.$set(this.record?.jsonConfig, 'NewsMLConfig', {
						TimeoutBetweenNews: 300,
						DelayBeforeAudio: 0,
						DelayAfterAudio: 0
					});
				}
			}
		}
	};
</script>
<style lang='scss'>
	.creative--insertion-newsml-settings {
	}
</style>
